import { render, staticRenderFns } from "./Cours_Inscription.vue?vue&type=template&id=6b452da6&"
import script from "./Cours_Inscription.vue?vue&type=script&lang=js&"
export * from "./Cours_Inscription.vue?vue&type=script&lang=js&"
import style0 from "./Cours_Inscription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports